import { render, staticRenderFns } from "./ListItemTransaction.vue?vue&type=template&id=64177576&scoped=true"
import script from "./ListItemTransaction.vue?vue&type=script&lang=js"
export * from "./ListItemTransaction.vue?vue&type=script&lang=js"
import style0 from "./ListItemTransaction.vue?vue&type=style&index=0&id=64177576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64177576",
  null
  
)

export default component.exports